/* eslint-disable react-hooks-ext/exhaustive-deps -- TODO(react-hooks): 2 hook(s) need dependency review; fix each and remove this directive */
import { useEffect } from "react";

const useValidationWrapper = (props: any) => {
  const { value, name, validator, dependencies = [] } = props;
  const valueString = value && value.toString();
  useEffect(() => {
    if (validator && name && validator.validate) {
      validator.validate({ value, name });
    }
  }, [valueString, ...dependencies]);
  return {};
};

export default useValidationWrapper;
